var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import useUserSesssion from './use-user-session';
const useModuleDetail = ({ loadKeywords, loadLessons, loadModules, loadPrequiz, loadProgress, loadQuizUsers, manageProgress }) => {
    const [moduleData, setModuleData] = useState();
    const [lessons, setLessons] = useState([]);
    const [preQuiz, setPreQuiz] = useState();
    const [studentProgressInModulePercent, setStudentProgressInModulePercent] = useState(0);
    const [studentScoreInModulePercent, setStudentScoreInModulePercent] = useState(0);
    const [prequizUser, setPrequizUser] = useState([]);
    const [internalLoading, setInternalLoading] = useState({
        firstLoad: false,
        keywords: false,
        module: false
    });
    const { currentUserSession } = useUserSesssion();
    const { idModule } = useParams();
    const loading = internalLoading.module || !internalLoading.firstLoad;
    const getModuleData = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            setInternalLoading(prev => (Object.assign(Object.assign({}, prev), { module: true })));
            const response = yield loadModules.studentModuleViewDetail(currentUserSession.user.id, parseInt(idModule), internalLoading.firstLoad ? 'false' : 'true');
            if (response) {
                setLessons(response.lessons);
                setModuleData(response.module);
                setPreQuiz(response.prequiz);
                setStudentProgressInModulePercent(response.studentProgressInModulePercent);
                setStudentScoreInModulePercent(response.studentScoreInModulePercent);
                setPrequizUser(response.prequizUser);
            }
            setInternalLoading(prev => (Object.assign(Object.assign({}, prev), { module: false })));
        }
        catch (error) {
            console.log(error);
        }
    });
    useEffect(() => {
        getModuleData();
    }, []);
    useEffect(() => {
        setInternalLoading(prev => (Object.assign(Object.assign({}, prev), { firstLoad: true })));
    }, []);
    return {
        loading,
        moduleData,
        currentUserSession,
        idModule,
        lessons,
        preQuiz,
        studentProgressInModulePercent,
        studentScoreInModulePercent,
        prequizUser
    };
};
export default useModuleDetail;
